import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { NavItemRoot, NavItemSub } from '@/components/nav-section/NavItem';
import { NavTree } from '@/components/nav-section/type';
import { getActive } from '@/components/nav-section/utils';

type NavListRootProps = {
  list: NavTree;
  isCollapse: boolean;
  onNavItemClick?: VoidFunction;
};

/**
 * Minimal@4 component.
 */
export function NavListRoot({ list, isCollapse, onNavItemClick }: NavListRootProps) {
  const { pathname } = useLocation();

  const active = getActive(list.path.split('?')[0], pathname);

  const hasActiveSub =
    pathname.includes(list.rootPathname) || (list.children || []).some((child) => getActive(child.path, pathname));

  const [open, setOpen] = useState(active || hasActiveSub);

  const hasChildren = list.children;

  if (hasChildren) {
    return (
      <>
        <NavItemRoot
          item={list}
          isCollapse={isCollapse}
          active={active}
          hasActiveSub={hasActiveSub}
          open={open}
          onOpen={() => setOpen(!open)}
          onNavItemClick={onNavItemClick}
        />

        {!isCollapse ? (
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {(list.children || []).map((item) => (
                <NavListSub key={item.path} list={item} onNavItemClick={onNavItemClick} />
              ))}
            </List>
          </Collapse>
        ) : null}
      </>
    );
  }

  return <NavItemRoot item={list} active={active} isCollapse={isCollapse} onNavItemClick={onNavItemClick} />;
}

type NavListSubProps = {
  list: NavTree<true>;
  onNavItemClick?: VoidFunction;
};

function NavListSub({ list, onNavItemClick }: NavListSubProps) {
  const { pathname } = useLocation();

  const active = getActive(list.path.split('?')[0], pathname);

  const [open, setOpen] = useState(active);

  const hasChildren = list.children;

  if (hasChildren) {
    return (
      <>
        <NavItemSub
          item={list}
          onOpen={() => setOpen(!open)}
          open={open}
          active={active}
          onNavItemClick={onNavItemClick}
        />

        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ pl: 3 }}>
            {(list.children || []).map((item) => (
              <NavItemSub
                key={item.path}
                item={item}
                active={getActive(item.path, pathname)}
                onNavItemClick={onNavItemClick}
              />
            ))}
          </List>
        </Collapse>
      </>
    );
  }

  return <NavItemSub item={list} active={active} onNavItemClick={onNavItemClick} />;
}
